import { gql } from '@apollo/client';

export const GENERATE_SHIPPING_LABEL_PDF = gql`
    mutation GenerateShippingLabelPdf($orderId: Long!) {
        generateShippingLabelPdf(orderId: $orderId)
    }
`;

// 新增批量生成PDF的mutation
export const GENERATE_BATCH_SHIPPING_LABEL_PDF = gql`
    mutation GenerateBatchShippingLabelPdf($orderIds: [Long!]!) {
        generateBatchShippingLabelPdf(orderIds: $orderIds)
    }
`;

export interface GenerateShippingLabelPdfVariables {
    orderId: number;
}

export interface GenerateShippingLabelPdfResponse {
    generateShippingLabelPdf: string;
}

// 新增批量生成PDF的接口
export interface GenerateBatchShippingLabelPdfVariables {
    orderIds: number[];
}

export interface GenerateBatchShippingLabelPdfResponse {
    generateBatchShippingLabelPdf: string;
} 